import React from "react";
import { NavLink } from "react-router-dom";
import avatar from "../../Assets/avatar.png";
import company_avatar from "../../Assets/company_avatar.png";
import company_avatar_active from "../../Assets/company_avatar_active.png";
import avatarActive from "../../Assets/avatarActive.png";
import "./sidenav.css"


function SideNav(props) {
    let { organization } = props;
    return (
      <div className="side-nav">
        <div className="settings-header">
          <div>{organization.display_name}</div>
        </div>
        <div className="links-container">
          <ul>
            <li
              className={
                window.location.pathname.includes("settings/profile")
                  ? "link-container active-link "
                  : "link-container"
              }
            >
              <NavLink
                to={`/organizations/${organization.display_name}/settings/profile`}
              >
                <img
                  src={
                    window.location.pathname.includes("settings/profile")
                      ? company_avatar_active
                      : company_avatar
                  }
                  alt="process icon"
                ></img>
                Organization Profile
              </NavLink>
            </li>
            {/* <li
              className={
                window.location.pathname.includes("/settings/notifications")
                  ? "link-container active-link "
                  : "link-container"
              }
            >
              <NavLink
                to={`/organizations/${organization.display_name}/settings/notification`}
              >
                <img
                  src={
                    window.location.pathname.includes("/settings/notifications")
                      ? notificationsActive
                      : notifications
                  }
                  alt="process icon"
                ></img>
                Notifications
              </NavLink>
            </li> */}
            {/* <li
              className={
                window.location.pathname.includes("/settings/billing")
                  ? "link-container active-link "
                  : "link-container"
              }
            >
              <NavLink
                to={`/organizations/${organization.display_name}/settings/billing`}
              >
                <img
                  src={
                    window.location.pathname.includes("/settings/billing")
                      ? billingActive
                      : billing
                  }
                  alt="process icon"
                ></img>
                Billing
              </NavLink>
            </li> */}
            <li
              className={
                window.location.pathname.includes("/settings/people")
                  ? "link-container active-link "
                  : "link-container"
              }
            >
              <NavLink
                to={`/organizations/${organization.display_name}/settings/people`}
              >
                <img
                  src={
                    window.location.pathname.includes("/settings/people")
                      ? avatarActive
                      : avatar
                  }
                  alt="process icon"
                ></img>
                People Management
              </NavLink>
            </li>
          </ul>
        </div>
      </div>
    );
}

export default SideNav;